'use strict';

var AV = require('./index');
var useLiveQuery = require('./use-live-query');
var useAdatpers = require('./use-adapters');

module.exports = useAdatpers(useLiveQuery(AV));


//////////////////
// WEBPACK FOOTER
// ./node_modules/leancloud-storage/dist/node/entry/index-live-query.js
// module id = HElL
// module chunks = 0